import React from 'react';
import { ReadAloud } from '@3plearning/question-components-library';
import { t } from '@lingui/macro';
import PropTypes from 'prop-types';

import { useLocalisation } from '../../../helpers/i18n/use-localisation';

const Tts = ({ onLocaleChange }) => {
  const { i18n } = useLocalisation();

  return (
    <ReadAloud
      onConfigChange={({ locale }) => onLocaleChange(locale)}
      popoverLabels={{
        readAloud: i18n._(t`Read aloud`),
        transcribe: i18n._(t`Transcribe`)
      }}
    />
  );
};

Tts.propTypes = {
  onLocaleChange: PropTypes.func.isRequired
};

export default Tts;
